import { styled } from '@linaria/react';
import { layout, space } from '../../theme/tokens';

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
  margin-top: ${space['space-800']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    margin-top: ${space['space-1600']};
    padding: 0 min(${space['space-1400']}, 8.5%);
  }
`;
